import isEmpty from 'lodash/isEmpty';

type NullableString = String | null;

const CHARACTER_LIMIT = 400;

export const isAbove400CharactersLimit = (...nullableStrings: NullableString[]) =>
  nullableStrings.reduce((sum, nullableString) => sum + (nullableString?.length || 0), 0) > CHARACTER_LIMIT;

export const areEmpty = (...nullableStrings: NullableString[]) =>
  nullableStrings.reduce((result, nullableString) => result && isEmpty(nullableString), true);
